import styled from 'styled-components';
import { LazyImage } from '../../../../../../components/LazyImage/LazyImage';
export const PanelListContent = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 25px;
  grid-row-gap: 0px;
  grid-template-rows: 1fr;
`;
export const PanelItemBanner = styled.a `
  padding-right: 0;
  margin: 10px 0 12px;
  height: 160px;
  width: 340px;
`;
export const PanelItemLink = styled.a `
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: #1185ed;
  margin: 20px 0;
  outline: none;
  text-decoration: none;
`;
export const RandomBannerImage = styled(LazyImage) `
  height: 100%;
  width: 100%;
  border-radius: 4px;
  object-fit: cover;
`;
export const LazyLoadWrapper = styled.div `
  height: 100%;
  width: 100%;

  > span {
    height: 100%;
    width: 100%;
  }
`;
export const ArrowIcon = styled.img `
  height: 22px;
  width: 22px;
  margin-left: 20px;
  margin-top: -2px;
  vertical-align: middle;
`;
//# sourceMappingURL=RandomBanner.styled.js.map